var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-field',{staticClass:"countries",attrs:{"id":_vm.getId(),"value":_vm.value,"items":_vm.countries,"empty-option":false,"disabled":_vm.disabled},on:{"selected":_vm.valueChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }